import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'


import { useModalStore } from '@features/modal'

import { QUERY_NAMES } from '@shared/contants'
import { ProductFilter } from '@shared/generated'
import { useFilters } from '@shared/hooks'
import { cn } from '@shared/lib/cn'
import { DynamicFilters } from '@shared/types'
import Button from '@shared/ui/button'
import { countFilters } from '@shared/uttils'

import ProductFilters from '.'

import styles from './styles.module.scss'

import SettingsIcon from '/icons/settings.svg'

interface ButtonProductFiltersProps {
  className?: string;
  externalFilters?: ProductFilter[];
}

export default function ButtonProductFilters (props: ButtonProductFiltersProps) {
  const { className, externalFilters } = props
  const { t: tc } = useTranslation('common')
  const { filters } = useFilters<DynamicFilters>({
    groupKey: QUERY_NAMES.PRODUCT_FILTERS,
  })
  const { openModal } = useModalStore()

  const COUNT = useMemo(() => {
    return countFilters(filters)
  }, [ filters ])

  return (
    <Button
      className={cn(styles.button, className)}
      size="medium"
      onClick={() => {
        openModal(
          'productFilters',
          <ProductFilters
            externalFilters={externalFilters}
            isModalStyle
            hideTitle
          />,
          {
            title: tc('filters.title'),
            disabledScroll: true,
            classes: {
              modal: styles['filters-modal'],
              body: styles['filters-modal-body'],
              content: styles['filters-modal-content'],
            },
          },
        )
      }}
    >
      <img src={SettingsIcon} alt="" />
      {tc('filters.title')} {COUNT > 0 && COUNT}
    </Button>
  )
}
